"use client";

import { motion } from "framer-motion";
import { MdEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { TiSocialFacebook, TiSocialLinkedin } from "react-icons/ti";
import { IoLogoYoutube } from "react-icons/io";

const TopBar = () => {
  return (
    <motion.div
      className="bg-[#0c4271] text-white text-sm py-2"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.5, ease: "easeOut" }}
    >
      <div className="max-w-[1280px] mx-auto  md:px-10 px-5 flex flex-wrap items-center justify-center small:justify-between gap-2 small:gap-4">
        {/* Left Section */}
        <div className="flex flex-wrap justify-center small:justify-start items-center space-x-2 small:space-x-4 text-center small:text-left">
          <a href="mailto:info@binaryops.co" className="flex items-center space-x-1">
            <MdEmail className="small:text-lg text-md" />
            <span>info@binaryops.co</span>
          </a>
          <span className="hidden small:block text-gray-500">|</span>
          <div className="flex items-center space-x-1">
            <FaLocationDot className="small:text-lg text-md" />
            <span>London, Islamabad, Peshawar</span>
          </div>
        </div>

        {/* Right Section (Social Media) */}
        <div className="flex flex-wrap justify-center small:justify-end items-center space-x-2 small:space-x-4">
          <span className="hidden small:inline">Follow Us</span>
          <span className="hidden small:inline text-gray-500">|</span>

          <a
            href="https://www.facebook.com/binaryops"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#1877F2] text-3xl hover:opacity-80"
          >
            <TiSocialFacebook className="text-white" />
          </a>

          <a
            href="https://www.youtube.com/@binaryopspvtltd"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#FF0000] text-3xl hover:opacity-80"
          >
            <IoLogoYoutube className="text-white size-5" />
          </a>

          <a
            href="https://www.linkedin.com/company/binary-ops"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0077B5] text-3xl hover:opacity-80"
          >
            <TiSocialLinkedin className="text-white" />
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default TopBar;
